const middleware = {}

middleware['external-enrollment-redirect'] = require('..\\middleware\\external-enrollment-redirect.ts')
middleware['external-enrollment-redirect'] = middleware['external-enrollment-redirect'].default || middleware['external-enrollment-redirect']

middleware['session'] = require('..\\middleware\\session.ts')
middleware['session'] = middleware['session'].default || middleware['session']

middleware['tc-password-protect'] = require('..\\middleware\\tc-password-protect.ts')
middleware['tc-password-protect'] = middleware['tc-password-protect'].default || middleware['tc-password-protect']

export default middleware
